export const POSTHOG_EVENTS = {
  USER_VIEWS_LIVE_FULL_VIDEO: 'user_views_live_full_video',
  USER_REQUESTS_LIVE_FULL_VIDEO: 'user_requests_live_full_video',
  USER_VIEWS_LIVE_PREVIEW_VIDEO: 'user_views_live_preview_video',
  USER_REQUESTS_LIVE_PREVIEW_VIDEO: 'user_requests_live_preview_video',
  USER_LEAVES_LIVE_VIDEO: 'user_leaves_live_video',
  USER_LEAVES_RECORDED_VIDEO: 'user_leaves_recorded_video',
  USER_ENCOUNTERS_VIDEO_ERROR: 'user_encounters_video_error',
  USER_REQUESTS_RECORDED_FULL_VIDEO: 'user_requests_recorded_full_video',
  USER_VIEWS_RECORDED_FULL_VIDEO: 'user_views_recorded_full_video',
  PAGE_VIEW: '$pageview',
  PAGE_LEAVE: '$pageleave',
  // EEVA events
  USER_SUBMITS_ANALYZE_EEVA_QUERY: 'user_submits_analyze_eeva_query',
  USER_SELECTS_EEVA_LIVE_VIEW: 'user_selects_eeva_live_view',
  USER_SELECTS_EEVA_ALL_HISTORICAL_EVENTS: 'user_selects_eeva_all_historical_events',
  USER_SELECTS_EEVA_VEHICLE_DETECTION: 'user_selects_eeva_vehicle_detection',
  USER_SELECTS_EEVA_MOTION_DETECTION: 'user_selects_eeva_motion_detection',
  USER_SELECTS_EEVA_PERSON_DETECTION: 'user_selects_eeva_person_detection',
  USER_UPDATES_EEVA_ANALYTIC_SETTINGS: 'user_updates_eeva_analytic_settings',
  USER_CLICKS_EEVA_TEST_DETECTION: 'user_clicks_eeva_test_detection',
  USER_CLICKS_EEVA_EXPANSION_PANEL: 'user_clicks_eeva_expansion_panel',
  // VSP events
  USER_SEARCHES_VSP_EVENTS: 'user_searches_vsp_events',
  USER_VIEWS_VSP_EVENT_HISTORY_VIDEO: 'user_views_vsp_event_history_video',
  USER_VIEWS_VSP_EVENT_DETAILS_PANEL: 'user_views_vsp_event_details_panel',
} as const;

export const POSTHOG_PROJECT_IDS = {
  PRODUCTION: 'phc_ziFxZGCxvRMdAJ9HaygHhUCrkVxqKwO9usoEeoTDOPU',
  STAGING: 'phc_XiOIzGuqKi3uworhT8jAoqkMNxkvbeJcdGkX9MU9R8G',
  DEVELOPMENT: 'phc_acMxybQsH0RsWmpqB0dMKarghtGzZOqOv3gOcqQbm0I',
} as const;
